import { render, staticRenderFns } from "./AppointmentSelectPatient.vue?vue&type=template&id=74a4c461&"
import script from "./AppointmentSelectPatient.vue?vue&type=script&lang=js&"
export * from "./AppointmentSelectPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports